module.exports = __webpack_public_path__ + "img/blue_140.694944f2.png";